import { render, staticRenderFns } from "./Kustomer.vue?vue&type=template&id=4052b747&"
import script from "./Kustomer.vue?vue&type=script&lang=js&"
export * from "./Kustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports